import cn from 'classnames';
import {
  AgeSegmentationIds,
  DogAgeSegmentationIds,
} from 'constants/segmentation';
import { AnimatePresence, m } from 'motion/react';
import { FormattedMessage } from 'react-intl';

interface Props {
  isOpen: boolean;
  selectedOption?: AgeSegmentationIds;
  onSelect: (value: AgeSegmentationIds) => void;
}

/**
 * It renders a list of age. It's used in the need capture component.
 */
const AgeSelectorDesktop: React.FC<Props> = ({
  isOpen,
  selectedOption,
  onSelect,
}) => (
  <AnimatePresence>
    {isOpen && (
      <m.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: 'auto' }}
        exit={{ opacity: 0, height: 0 }}
        transition={{ duration: 0.15, ease: 'easeInOut' }}
        className="bg-other-white text-grey-800 absolute z-50 mt-1 flex max-h-72 w-full flex-col overflow-hidden overflow-y-auto rounded-lg py-1 text-sm font-normal shadow-sm"
      >
        {Object.entries(DogAgeSegmentationIds).map(([key, value]) => (
          <button
            key={key}
            className={cn(
              'w-full px-4 py-2 text-left',
              selectedOption === value
                ? 'bg-grey-100 hover:bg-grey-100'
                : 'hover:bg-grey-50'
            )}
            onClick={() => onSelect(value)}
          >
            <FormattedMessage
              id={`common:pet-profile:age-selector:desktop-age-selector:${value}`}
            />
            <span className="text-text-secondary block text-xs leading-[15px] whitespace-nowrap">
              <FormattedMessage
                id={`common:pet-profile:age-selector:desktop-age-selector:description:${value}`}
              />
            </span>
          </button>
        ))}
      </m.div>
    )}
  </AnimatePresence>
);

export default AgeSelectorDesktop;
